
function Donation($el) {
	var $form = $el.find('#donateForm');

	var $classyBaseURL = $form.attr('action');

	function donateToggle() {
		// Toggle text for amount
		var amount = $(this).attr('data-amount');
		$el.find('.donation-text[data-amount="'+amount+'"]').addClass('amountSelected').siblings().removeClass('amountSelected');
	}

	function amountToggle() {
		$(this).addClass('button-selected').siblings().removeClass('button-selected');
	}

	function customAmount() {
		$el.find('.button-amount').removeClass('button-selected');
	}

	function onFormSubmit(e) {
		e.preventDefault();
		var amount = null;

		if($form.find('.donate-text-input').val()) {
			amount = $form.find('.donate-text-input').val();

		} else if($form.find('input[name="amount"]:checked').val()) {
			amount = $form.find('input[name="amount"]:checked').val();

		}

		console.log($form.find('input[name="amount"]:checked').val())

		if(amount) {
			window.open(
				$classyBaseURL + '?amount=' + amount,
				'_blank'
			);
		} else {
			//amount is null
			return false;
		}
	}


	function bindEvents() {
		$el = $el;
		$el.find('.button-amount').on('mouseenter', donateToggle);
		$el.find('.button-amount').on('click', amountToggle);
		$el.find('.custom-amount').on('click', customAmount);
		$el.find('#donateForm').on('submit', onFormSubmit);
	}

	this.init = function ($el) {
		bindEvents();

		return this;
	}

	return this.init($el);
}

export default Donation;



// WEBPACK FOOTER //
// ./src/js/components/donation.js